import { render, staticRenderFns } from "./CategorySeoContent.vue?vue&type=template&id=910c2b18&scoped=true&"
import script from "./CategorySeoContent.vue?vue&type=script&lang=js&"
export * from "./CategorySeoContent.vue?vue&type=script&lang=js&"
import style0 from "./CategorySeoContent.vue?vue&type=style&index=0&id=910c2b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910c2b18",
  null
  
)

export default component.exports